import React from "react";
import BaseValueModal from "./BaseValueModal";
import { IndustryForm } from "./IndustryModal";
import AverageSalaryModal from "./AverageSalaryModal";

const MODAL_COMPONENTS = {
  AVG_INDUSTRY_INCOME: IndustryForm,
  BASE_VALUES: BaseValueModal,
  AVG_REGION_INCOME: AverageSalaryModal,
};

export const ModalFactory = ({ type, data, onClose, onSave }) => {
  if (!type) return null;

  const ModalComponent = MODAL_COMPONENTS[type];

  if (!ModalComponent) {
    return null;
  }

  return (
    <ModalComponent defaultValues={data} onClose={onClose} onSubmit={onSave} />
  );
};
